import React, {useEffect} from "react";
import {Grid, Typography} from "@mui/material";
import {theme} from "../Theme/Theme";
import {baseTheme} from "../Theme/Theme";
import resumeBackground from "../Assest/resume_background2.jpg";



const localStyles = {
    background:{
        backgroundImage: `url(${resumeBackground})`,
        backgroundPosition:'center',
        backgroundSize:'cover',
        backgroundAttachment:'fixed',
        backgroundRepeat:'no-repeat',
        minHeight:'200vh',
        height:'auto',
        width:'100%',
        //opacity:0.7,
        [theme.breakpoints.down("md")]:{
            height:'auto'
        },
        [theme.breakpoints.down("sm")]:{
            //height: '50em'
        }
    },
    mainBody:{

        backgroundColor:baseTheme.white,
        padding:'8rem 10rem',
        opacity:0.85,
        minHeight:'100vh',
        height:'auto',
        width:'100%',
        [theme.breakpoints.down("md")]:{
            padding:'2rem',
            minHeight:'100vh'
        },
        [theme.breakpoints.down("sm")]:{
            minHeight:'100vh',
            height:'auto'
        }
    },
    buttonContainer:{
        paddingTop:'2rem'
    },
    mainHeader:{
        height:'100vh',
    },
    webHeaderText:{
        fontSize:'4rem',
        [theme.breakpoints.down("md")]:{
            fontSize:'3rem'
        }
    },
    webHeaderTextContainer:{
        paddingBottom:'10rem',
        paddingRight:'0.5rem',
        paddingLeft: '0.5rem',
        [theme.breakpoints.down("md")]:{
            paddingBottom: '2em'
        }
    },
    webHeaderTextSub:{
        fontSize: '2rem',
        [theme.breakpoints.down("md")]:{
            fontSize:'1.25rem'
        }
    },
    textStyle: {
        [theme.breakpoints.down("md")]:{
            //textAlign:'center',
            padding: '1rem'
        }
    }
};



export default function Resume2 (props) {

    useEffect(() => {
        //window.scrollTo({ top: 0, behavior: 'smooth' });
        let top = document.getElementById('top');
        top.scrollIntoView({behavior: 'smooth'});
    },[]);


    return(
        <>
            <Grid container direction={'column'} sx={localStyles.background} justifyContent={'center'}>

                {/*web page header*/}
                <Grid id={'top'} container item direction={'row'} sx={localStyles.mainHeader} >

                    <Grid container item justifyContent={'center'} alignItems={'center'}>
                        <Grid container item sx={localStyles.webHeaderTextContainer} justifyContent={'center'}>
                            <Grid item sx={{backgroundImage:'linear-gradient(to right, RGBA(21,0,80,0.2), RGBA(21,0,80,1))' , padding:'1em', opacity:1, border:`1px solid ${baseTheme.brightPurple}`, borderRadius:'10px'}} >
                                <Typography sx={localStyles.webHeaderText} variant={'h1'} textAlign={'center'} gutterBottom>“Systems built well scale quietly.”</Typography>
                                <Typography sx={localStyles.webHeaderTextSub} variant={'subtitle1'} textAlign={'center'}> – Engineering mindset</Typography>
                            </Grid>
                        </Grid>
                    </Grid>

                </Grid>

                {/*web page body*/}
                <Grid container item direction={'column'} sx={localStyles.mainBody} justifyContent={'center'} >
                    <Grid item>
                        <Typography sx={localStyles.textStyle} variant={'h2'} gutterBottom>Overview</Typography>
                        <Typography sx={localStyles.textStyle} variant={'body1'} gutterBottom>
                            I’m a backend engineer specialising in Python and system architecture, focused on building scalable, reliable systems used in real production environments.
                        </Typography>

                        <Typography sx={localStyles.textStyle} variant={'body1'} gutterBottom>
                            My work centres around APIs, automation platforms, and data pipelines — improving performance, reducing operational complexity, and enabling teams to operate more efficiently.
                        </Typography>

                        <Typography sx={localStyles.textStyle} variant={'body1'} gutterBottom>
                            I’ve designed and built systems handling thousands of automated processes daily, with a strong focus on performance, reliability, and maintainability.
                        </Typography>
                        <Typography variant={'h2'} gutterBottom sx={localStyles.textStyle}>Core Expertise</Typography>
                        <Typography variant={'body1'} gutterBottom sx={localStyles.textStyle}>
                            Backend development (Python, Django, FastAPI, Laravel), API design and integrations, data pipelines and automation systems, system architecture and performance optimisation, cloud infrastructure (AWS), CI/CD and containerised deployments.
                            <br/><br/>
                            I also have experience working across Node.js and frontend frameworks when required, but my primary focus remains backend engineering and system design.
                        </Typography>
                        <Typography variant={'h2'} gutterBottom sx={localStyles.textStyle}>Professional Experience</Typography>
                        <Typography variant={'body1'} sx={localStyles.textStyle}>
                            <Typography variant={'h4'} gutterBottom sx={localStyles.textStyle}>
                                2018–present: Backend-focused engineering across production systems, automation platforms, and full-stack applications
                            </Typography>

                            {/* Wilton Bradley */}
                            <Typography variant={'h5'} gutterBottom sx={localStyles.textStyle}>2025 – Present - Senior Backend Engineer (permanent) Wilton Bradley</Typography>
                            <Typography variant={'body1'} gutterBottom sx={localStyles.textStyle}>
                                Designing and building backend systems and automation platforms supporting data-driven workflows across the business.
                                <br/>
                                • Designed and led development of a custom Python orchestration platform replacing an existing system after internal evaluation
                                <br/>
                                • Processes thousands of jobs/day across multiple data pipelines
                                <br/>
                                • Improved execution performance by ~20–30% and reduced failure rates by ~30%
                                <br/>
                                • Built scalable APIs and backend services for automation and integrations
                                <br/>
                                • Focused on system architecture, reliability, and performance across production systems
                                <br/>
                                • Supports multiple internal systems and cross-team workflows
                            </Typography>

                            {/* Rouic */}
                            <Typography variant={'h5'} gutterBottom sx={localStyles.textStyle}>2023 - Senior Backend / Full Stack Engineer (permanent) Rouic Ltd</Typography><Typography variant={'body1'} gutterBottom sx={localStyles.textStyle}>
                            Worked across multiple production systems, focusing on backend services, APIs, and system architecture.
                            <br/>
                            • Led backend development for scalable web applications and services
                            <br/>
                            • Improved CI/CD pipelines and automated testing, increasing reliability and deployment efficiency
                            <br/>
                            • Designed and maintained APIs and backend systems used across multiple platforms
                            <br/>
                            • Collaborated closely with the team to deliver stable, maintainable solutions
                            </Typography>

                            {/* FlexAbility*/}
                            <Typography variant={'h5'} gutterBottom sx={localStyles.textStyle}>2022-2023 - Full Stack Engineer (contract) Flexytrainer </Typography>
                            <Typography variant={'body1'} gutterBottom sx={localStyles.textStyle}>
                                Built a production-ready platform from scratch, focusing on backend systems and scalable architecture.
                                <br/>
                                • Designed and developed backend services using Python and Django
                                <br/>
                                • Implemented microservices architecture and automated testing pipelines
                                <br/>
                                • Deployed and managed infrastructure on AWS
                                <br/>
                                • Delivered a stable system supporting real-world business operations
                            </Typography>

                            {/*The Garson*/}
                            <Typography variant={'h5'} gutterBottom sx={localStyles.textStyle}>2021 - 2022 - Project Lead (contract) The Garson</Typography>
                            <Typography variant={'body1'} gutterBottom sx={localStyles.textStyle}>
                                Led development of an MVP platform, focusing on backend systems and architecture.
                                <br/>
                                • Designed system architecture and backend services
                                <br/>
                                • Built APIs and data handling logic for the application
                                <br/>
                                • Delivered a working product from concept to production
                            </Typography>
                            {/*Sync Bin*/}
                            <Typography variant={'h5'} gutterBottom sx={localStyles.textStyle}>2020 - Front End Developer (contract) SyncBin </Typography>
                            <Typography variant={'body1'} gutterBottom sx={localStyles.textStyle}>
                            Contributed to UI development within a small product team.
                            <br/>
                            • Built frontend components using React
                            <br/>
                            • Collaborated with backend developers to deliver a functional product
                            </Typography>
                            {/*Bot*/}
                            <Typography variant={'h5'} gutterBottom sx={localStyles.textStyle}>2019 - 2020 - Automation Developer (contract) Private Hire </Typography>
                            <Typography variant={'body1'} gutterBottom sx={localStyles.textStyle}>
                                Built backend automation systems to reduce manual processes and collect data from web sources.
                                <br/>
                                • Designed and implemented data collection and automation workflows
                                <br/>
                                • Used Python and Selenium to build scraping and automation systems
                                <br/>
                                • Delivered solutions that significantly reduced manual workload
                            </Typography>
                        </Typography>
                    </Grid>

                </Grid>

            </Grid>
        </>
    )
};
